import * as React from 'react'
import { Button, Spinner } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import InputFieldPassword from 'components/InputFieldPassword'
import { preRegisterFormItems } from 'utilities/resources/formItems'
import { ErrorChecker, FormErrorMessage, passwordValidator } from 'utilities/validators'
import { PropertySetter } from 'utilities/typeUtility'
import Footer from 'components/Footer'
import Header from 'components/Header'
import { scrollToAnchor } from 'utilities/helper'
import { passwordRegistrationAPI } from 'api/password'

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  // パスワード変更フォームの値
  const [formValues, setFormValues] = React.useState({
    password: '',
    passwordConfirm: '',
  })
  const [enabled, setEnabled] = React.useState(false)
  const [committed, setCommitted] = React.useState(false)
  React.useEffect(() => {
    setEnabled(formValues.password.trim() !== '')
  }, [formValues.password])

  // パスワード変更フォームの値を更新する関数
  const setter = new PropertySetter(setFormValues)
  // パスワード変更フォームのエラーメッセージ
  const [errorValues, setErrorValues] = React.useState<FormErrorMessage<typeof formValues>>()
  const errorChecker = new ErrorChecker<typeof formValues>({
    password: preRegisterFormItems.password,
    passwordConfirm: preRegisterFormItems.passwordConfirm,
  })
  const newPassword = formValues?.password
  const { token } = useParams<{ token: string }>()
  // パスワード変更処理
  const handleSubmit = async () => {
    errorChecker.init()
    errorChecker.check(passwordValidator(formValues.password), 'password')
    errorChecker.check(passwordValidator(formValues.passwordConfirm, formValues.password), 'passwordConfirm')
    setErrorValues(errorChecker.getErrorMessageData())
    if (errorChecker.isValid()) {
      setCommitted(true)
      if (!newPassword || !token) {
        alert('パスワード変更に失敗しました。')
        return navigate('/login')
      }
      await passwordRegistrationAPI({ newPassword, token }, (result) => {
        if (!result) {
          alert('パスワード変更に失敗しました。パスワードをご確認の上、再度お試しください。')
          return navigate(0)
        }
        setCommitted(false)
        return navigate('/login')
      })
    } else {
      scrollToAnchor(errorChecker.getFirstInvalidItemId())
    }
  }

  return (
    <>
      <Header title="パスワード登録" />
      <main>
        <section className="mx-4 my-5">
          <form>
            <InputFieldPassword
              name={preRegisterFormItems.password.name}
              value={formValues.password}
              onChange={(e) => setter.set('password', e)}
              label="新しいパスワード"
              type="password"
              placeholder="新しいパスワードを入力してください"
              errors={[errorValues?.password ?? '']}
              bold
              className="mb-1"
            />

            <p className="text-muted mb-4">
              ※半角英数字を含む文字で入力してください
              <br />
              ※大文字と小文字を含む文字で入力してください
              <br />
              ※8文字以上で入力してください
            </p>

            <InputFieldPassword
              name={preRegisterFormItems.passwordConfirm.name}
              value={formValues.passwordConfirm}
              onChange={(e) => setter.set('passwordConfirm', e)}
              label={preRegisterFormItems.passwordConfirm.label}
              type="password"
              placeholder="新しいパスワードを再入力してください"
              errors={[errorValues?.passwordConfirm ?? '']}
              bold
              className="mb-4"
            />

            <div className="mt-5">
              <Button variant="primary" className="w-100 py-4" onClick={handleSubmit} disabled={!(enabled && !committed)}>
                <Spinner className="me-2" as="span" animation="border" size="sm" role="status" aria-hidden="true" hidden={!committed} />
                登録する
              </Button>
            </div>
          </form>
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
